import { BeautyType } from "./v1";

export const beautyTypeOptions = Object.entries(BeautyType)
	.filter(([, value]) => {
		return isNaN(Number(value));
	})
	.map(([value, label]) => {
		return { value, label };
	});
